<template>
  <div class="comments">
    <div class="page__row">
      <div class="page__item" style="width: 100%;">
        <AppTextarea :value="value"
                     @value-changed="setComment"
                     :disabled="disabled"
        />
      </div>
    </div>

    <div class="page__row">
      <div class="page__item">
        <AppButtonComment title="Оставить комментарий"
                          width="250px"
                          type="fourth"
                          @click.stop.native="createComment"
                          :disabled="disabled"
        />
      </div>
      <transition name="fade">
        <div class="page__item" v-show="oldComment">
          <AppButtonCommentSave title="Сохранить изменения"
                                width="250px"
                                type="main"
                                @click.stop.native="saveComment"
                                :disabled="disabled"
          />
        </div>
      </transition>
    </div>

    <transition name="fade" v-for="comment in comments" :key="comment.created_at">
      <div class="comments__item">
        <div class="comments__controls" v-if="isEditable && !disabled">
          <div>
              <div class="comments__menu" @click.stop.prevent="toggleControls(comment.id)" v-if="currentUser.id === comment.user_id">
                <svg class="ellipsis-icon" viewBox="0 0 23 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="2" cy="2" r="2" fill="currentColor"/>
                  <circle cx="11" cy="2" r="2" fill="currentColor"/>
                  <circle cx="21" cy="2" r="2" fill="currentColor"/>
                </svg>
              </div>
            <transition name="fade">
              <AppPopupControls v-show="comment.isControlsActive"
                                :active-buttons="{add: false, edit: true, remove: true}"
                                @edit-this-item="setEdit(comment.value)"
                                @remove-this-item="deleteComment(comment)"
              />
            </transition>
          </div>
        </div>

        <p class="comments__user">{{ comment.position ? comment.position + ',' : '' }} {{ comment.name }}</p>

        <p class="comments__text">{{comment.value}}</p>

        <span class="comments__date">{{comment.created_at}}</span>

      </div>
    </transition>
  </div>
</template>

<script>
import AppButtonComment from '@/components/page/button/AppButtonComment'
import AppTextarea from '@/components/page/input/AppTextarea'
import AppButtonCommentSave from '@/components/page/button/AppButtonCommentSave'
import AppPopupControls from '@/components/page/popup/AppPopupControls'
export default {
  name: 'TheCommentsBlock',
  components: { AppPopupControls, AppButtonCommentSave, AppTextarea, AppButtonComment },
  props: {
    value: String,
    comments: Array,
    isEditable: {
      default: false,
      type: Boolean
    },
    oldComment: String,
    valid: {
      type: Object,
      default () {
        return { message: '', type: null }
      }
    },
    isControlsActive: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    }
  },

  methods: {
    setEdit (value) {
      this.$emit('set-edit', value)
    },
    setComment (value) {
      this.$emit('value-changed', value)
    },
    createComment () {
      this.$emit('create-comment')
    },
    saveComment () {
      this.$emit('save-comment')
    },
    deleteComment (value) {
      this.$emit('delete-comment', value)
    },
    toggleControls (value) {
      this.$emit('toggle-controls', value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/vars';
@import '../../assets/css/system/mixins';

.comments {
  width: 100%;

  &__item {
    margin-bottom: 20px;
    background: $color_sixth;
    border-radius: 3px;
    width: 100%;
    padding: 20px 22px 18px;
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__user {
    color: $color_info;
    font-weight: 500;
  }

  &__text {
    color: #000000;
    line-height: 24px;
    margin-top: 12px;
  }

  &__date {
    position: absolute;
    bottom: 12px;
    right: 16px;
    font-size: 12px;
    line-height: 18px;
    color: #697178;
  }

  &__controls {
    position: absolute;
    right: 22px;
    top: 20px;
  }

  &__control {
    background: none;
    font-size: 14px;
    cursor: pointer;
  }

  &__edit {
    color: #697178;
  }

  &__delete {
    color: $color_error;
  }

  &__menu {
    cursor: pointer;
    text-align: right;
    color: #95a4c0;
  }
}
</style>
